<script lang="ts">
  import { icon } from '#app/lib/icons'
  import preq from '#app/lib/preq'
  import { commands } from '#app/radio'
  import { I18n } from '#user/lib/i18n'

  let intervalId = $state(null)
  let active = $state(false)

  interface GlobalFlashState {
    title: string
    icon: string
    message: string
  }

  let flashState: GlobalFlashState = $state()

  function showNetworkError () {
    flashState = {
      title: I18n('offline_help'),
      icon: 'bolt',
      message: I18n('you are offline'),
    }
    if (active) return
    active = true
    if (intervalId == null) intervalId = setInterval(checkState, 1000)
  }

  function hideNetworkError () {
    if (!active) return
    active = false
    flashState = null
    if (intervalId != null) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  const checkState = () => preq.get('/api/tests').then(hideNetworkError)

  commands.setHandlers({
    'flash:message:show:network:error': showNetworkError,
  })
</script>

{#if flashState}
  <div class="global-flash-message" title={flashState.title} class:active>
    {@html icon(flashState.icon)}
    <span>{flashState.message}</span>
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .global-flash-message{
    background-color: $success-color;
    @include radius(3px);
    padding: 0.8em 1em;
    margin: 1em;
    color: white;
    @include display-flex(row, center, center);
    @include position(fixed, -10em, 0, null, null, 100);
    @include transition(top);
    &.active{
      background-color: $warning-color;
      inset-block-start: 0;
    }
    &:not(.active){
      display: none;
    }
  }
  /* Very small screens */
  @media screen and (width < $very-small-screen){
    .global-flash-message{
      inset-inline-start: 0;
      &.active{
        inset-block-start: auto;
        inset-block-end: 0;
      }
    }
  }
</style>
